import { SHIPPING_BANNER } from "../../data/collection";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 left-0 z-[60] w-full bg-[#050505] border-b border-white/10"
    >
      <div className="flex items-center justify-center gap-2 md:gap-3 px-4 py-2 md:py-2.5">
        <span className="text-[var(--kln-gold)] text-xs leading-none">&#10022;</span>
        <p className="font-body text-[9.5px] md:text-[11px] uppercase tracking-[0.28em] md:tracking-[0.32em] text-white/85 text-center">
          {SHIPPING_BANNER}
        </p>
        <span className="text-[var(--kln-gold)] text-xs leading-none">&#10022;</span>
      </div>
    </div>
  );
}
